import { useState } from "react";
import { motion, MotionConfig } from "framer-motion";
import Left from "../left.svg";
import Right from "../right.svg";
import "./Slides.css";
import "./common.css";

const ImageCarousel = ({ projectId, images }) => {
  const [currentSlide, setCurrentSlide] = useState(Math.floor(images.length / 2));
  const [hoveredArrow, setHoveredArrow] = useState(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [popupImage, setPopupImage] = useState("");

  const isMobile = window.innerWidth < 786;

  const handlePrevious = () => {
    setCurrentSlide((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentSlide((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  const handleImageClick = (index) => {
    setCurrentSlide(index);
  };

  const openPopup = (image) => {
    setPopupImage(image);
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
    setPopupImage("");
  };

  return (
    <div className="carousel_container flex flex-col items-center overflow-hidden relative">
      <MotionConfig transition={{ duration: 0.7, ease: [0.32, 0.72, 0, 1] }}>
        <div className="w-full md:max-w-[50rem] flex items-center md:max-h-[70vh]">
          {!isPopupOpen && (
            <button
              className={`prev-arrow ${hoveredArrow === "prev" ? "visible" : "hidden"}`}
              onClick={handlePrevious}
            >
              <img src={Left} alt="Left" className="h-8 w-8 " />
            </button>
          )}

          <motion.div
            key={isMobile ? 'mobile' : 'desktop'} // force remount on layout change
            initial={false}
            className="flex gap-2 flex-nowrap w-full"
            animate={{
              x: isMobile
                ? `calc(-${currentSlide} * 98.2% - ${currentSlide}rem)`
                : `calc(-${currentSlide} * 49.5rem - ${currentSlide}rem)`
            }}
            transition={{ type: 'spring', stiffness: 300, damping: 30 }}
           >
            {images.map((image, idx) => (
              <motion.img
                key={idx}
                src={`/images/${projectId}/${image}`}
                alt={`Slide ${idx}`}
                animate={{ opacity: idx === currentSlide ? 1 : 0.4 }}
                className={`object-cover min-w-full md:min-w-[50rem] max-h-[70vh] cursor-pointer ${
                  idx === currentSlide
                    ? "slide-image"
                    : idx < currentSlide
                      ? "slide-image-prev"
                      : "slide-image-next"
                }`}
                onMouseEnter={() => {
                  if (idx === 0) {
                    setHoveredArrow("prev");
                  } else if (idx === images.length - 1) {
                    setHoveredArrow("next");
                  } else {
                    setHoveredArrow(idx > currentSlide ? "next" : "prev");
                  }
                }}
                onClick={() => {
                  if (idx === currentSlide) {
                    openPopup(`/images/${projectId}/${image}`);
                  }
                }}
              />
            ))}
          </motion.div>

          {!isPopupOpen && (
            <button
              className={`next-arrow ${hoveredArrow === "next" ? "visible" : "hidden"}`}
              onClick={handleNext}
            >
              <img src={Right} alt="Right" className="h-8 w-8" />
            </button>
          )}
        </div>
      </MotionConfig>

      {/* Thumbnails */}
      <div className="thumbnail-container">
        {images.map((image, index) => (
          <div className={` ${index === currentSlide ? "" : "thumbnail-slide"}`} key={index}>
            <img
              key={index}
              src={`/images/${projectId}/${image}`}
              alt={`Thumbnail ${index + 1}`}
              className={`thumbnail ${index === currentSlide ? "active" : ""}`}
              onClick={() => handleImageClick(index)}
            />
          </div>
        ))}
      </div>

      {/* Image Popup */}
      {isPopupOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50">
          <button
            onClick={closePopup}
            className="absolute top-6 right-6 text-white text-4xl font-bold z-50"
          >
            &times;
          </button>
          <img
            src={popupImage}
            alt="Full view"
            className="max-w-full max-h-full object-contain p-4"
          />
        </div>
      )}
    </div>
  );
};

export default ImageCarousel;
